module.exports = __webpack_public_path__ + "img/p14_2.5478d699.png";